import { POUNDS, KILOS } from "MODULES/parts/constants";
import { displayDecimal } from "LIB/formatters/number";

export const poundsToKilograms = lbs => 0.4536 * lbs;

export const kilogramsToPounds = kg => kg / 0.4536;

const ozToKilograms = oz => oz * 0.0283495;

export const calculateValue = (unit, value = 0) => {
  if (!unit) {
    return null;
  }
  const map = {
    [POUNDS]: poundsToKilograms(value),
    [KILOS]: kilogramsToPounds(value)
  };

  return Math.ceil(map[unit]);
};

export const calculateNetValue = (unit, value, ozValue) => {
  if (!unit) return null;

  const map = {
    [POUNDS]: poundsToKilograms(value) + ozToKilograms(Number(ozValue)),
    [KILOS]: kilogramsToPounds(value)
  };

  return displayDecimal(map[unit], 1000);
};

export function conversionUnit(unit) {
  if (!unit) {
    return null;
  }
  return unit === POUNDS ? "Kilograms" : "Pounds";
}

export function conversionUnitAbbrev(unit) {
  if (!unit) {
    return null;
  }
  return unit === POUNDS ? "kg" : "lb";
}



// WEBPACK FOOTER //
// ./app/lib/formatters/weight.js